// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Menu from 'esm-web-pro/components/Menu';
import { Box } from 'grommet';


type Props = {
    label: ?React.Node,
    choices: Array<{
        label: React.Node,
        onClick: Function,
    }>,
};

const PageMainSelector = (props: Props) => {
    const { label, choices } = props;

    return (
        <Box direction="row" align="center">
            <Menu
                label={label || (
                    <FormattedMessage
                        id="main-page-select-default"
                        defaultMessage="Select table..."
                    />
                )}
                choices={choices}
            />
        </Box>
    );
};

export default PageMainSelector;
